import styled from 'styled-components';
import { Grid, TableCell, Chip, MenuItem, InputAdornment } from '@mui/material';

export const MultiSearchSelectContainer = styled.div`
  padding-bottom: 16px;
  padding: 0;
`;

export const MenuWrapper = styled.div`
  max-height: 240px;
  overflow: auto;
`;

export const SecondaryActionsWrapper = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: end;
  flex-wrap: wrap;
  height: 100%;
`;

export const ChipBar = styled(Grid)`
  display: flex;
  align-items: end;
  overflow-x: auto;
  padding-top: 5px;
`;

export const TitleContainer = styled(TableCell)`
  width: 24px !important;
  border: none !important;
`;

export const ValueContainer = styled(TableCell)`
  padding: 0px 8px !important;
  border: none !important;
`;

export const TableWrapper = styled.div`
  flex: 1;
  margin-left: 8px;
  align-self: center;
  display: flex;
  flex-direction: column;
`;

export const StyledChip = styled(Chip)`
  background-color: grey !important;
  color: white !important;
  margin: 5px 5px 5px 0px;
  fontsize: 10px;
`;

export const ChildMenuItemContainer = styled.div`
  background-color: ${({ checked }) => (checked ? '#f2f2f2' : 'white')};
`;

export const StyledMenuItem = styled(MenuItem)`
  height: 40px;
  left: 0;
  width: 100%;
`;

export const StyledChildMenuItem = styled(MenuItem)`
  height: 40px;
  left: 30px;
  width: 100%;
`;

export const CustomInputAdornment = styled(InputAdornment)`
  padding: 0 !important;
  margin: 0 !important;
  min-width: auto !important;
`;
